import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL || process.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY || process.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file for VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Ensure sessions are properly detected and refreshed
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
    storageKey: 'sb-auth-token',
  }
});

// Graceful lifecycle handler for Browser Back-Forward Cache (bfcache):
// Chrome abruptly terminates open WebSockets when a page enters bfcache, producing:
// "WebSocket connection to 'wss://.../realtime/v1/websocket...' failed: Page entered Back-Forward Cache."
// Cleanly closing the realtime socket on pagehide/freeze prevents this error across all pages.
if (typeof window !== 'undefined') {
  const disconnectRealtime = () => {
    try {
      if (supabase?.realtime) {
        supabase.realtime.disconnect();
      }
    } catch (e) {}
  };

  const reconnectRealtime = (e) => {
    try {
      if (e?.persisted && supabase?.realtime) {
        supabase.realtime.connect();
      }
    } catch (e) {}
  };

  window.addEventListener('pagehide', disconnectRealtime, { capture: true });
  window.addEventListener('freeze', disconnectRealtime, { capture: true });
  window.addEventListener('pageshow', reconnectRealtime, { capture: true });
  window.addEventListener('resume', reconnectRealtime, { capture: true });
}
